import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { TextField } from "@/shared/components/Form/TextField";
import { ColorPickerField } from "@/shared/components/Form/ColorPickerField";
import { Markdown as MarkdownField } from "@/shared/components/Form/Markdown";
import type {
  PlatformBlockComponent,
  PlatformBlockProps,
} from "../../../types";
import { BlockFormHeader } from "../BlockFormHeader";

export const Markdown: PlatformBlockComponent = ({
  name,
}: PlatformBlockProps) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="MARKDOWN" />
      <Grid container spacing={2}>
        <Grid size={12}>
          <MarkdownField
            name={`${name}.text`}
            label={t("platformBlocks.fields.text")}
            type="text"
            multiline
            rows={6}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ColorPickerField
            name={`${name}.backgroundColor`}
            label={t("platformBlocks.fields.backgroundColor")}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ColorPickerField
            name={`${name}.textColor`}
            label={t("platformBlocks.fields.textColor")}
            fullWidth
          />
        </Grid>
        <Grid size={12}>
          <TextField
            name={`${name}.maxWidth`}
            label={t("platformBlocks.fields.maxWidth")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            name={`${name}.paddingTop`}
            label={t("platformBlocks.fields.paddingTop")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            name={`${name}.paddingBottom`}
            label={t("platformBlocks.fields.paddingBottom")}
            type="number"
            fullWidth
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
